<template>
  <div class="project">
    <a class="button is-small" @click="download_report()" :disabled="!project.reports ||
      !project.reports.report
      " style="border: 0; margin-right: 0px; margin-top: 5px">
      <svg v-if="
        project.reports &&
        project.reports.report
      " viewBox="0 0 100 100" class="image is-32x32">
        <use xlink:href="@/assets/icons/helper_sprite.svg#download-fill" />
      </svg>
      <svg v-else viewBox="0 0 100 100" class="image is-32x32">
        <use xlink:href="@/assets/icons/helper_sprite.svg#download" />
      </svg>
    </a>
    <div>
      <div class="project__field field has-addons">
        <p class="control">
          <a class="button">
            <span @click.exact="
              SET_ACTIVE_PROJECT(project), (is_ortho = true);
            set_ortho_layer();
            " @click.ctrl="
              SET_ACTIVE_PROJECT(project), (is_ortho = true);
            set_ortho_layer(false);
            " :class="{
              'active-project': is_ortho,
              'has-text-info':
                active_project && active_project.uid === project.uid,
            }" class="project__name is-medium-14-500-42">
              <span v-tooltip="project.name">{{
                project.name | truncate(20)
                }}</span>
            </span>
          </a>
        </p>
        <p class="control">
          <a @click="is_open_collapse = !is_open_collapse" class="button card-header-icon">
            <span class="icon" style="border-radius: 8px">
              <svg v-if="!is_open_collapse" viewBox="0 0 100 100" class="image is-24x24">
                <use xlink:href="@/assets/icons/sprite.svg#collapse" />
              </svg>
              <svg v-else viewBox="0 0 100 100" class="image is-24x24">
                <use xlink:href="@/assets/icons/sprite.svg#expand" />
              </svg>
            </span>
          </a>
        </p>
      </div>
      <b-collapse :class="{ card: is_open_collapse }" :open.sync="is_open_collapse" style="padding-top: 1rem">
        <div class="card-content">
          <div class="columns project__btns">
            <div class="map" style="margin-left: 2px">
              <div class="field is-pulled-left">
                <input @change="set_ortho_layer(false)" v-model="is_ortho" :checked="is_ortho"
                  class="is-checkradio is-info is-small" type="checkbox" :id="'map' + project.uid" />
                <label :for="'map' + project.uid">
                  <span>
                    {{ localization("app-map", "Map") }}
                  </span>
                </label>
              </div>
            </div>
            <div class="features" style="padding-left: 0">
              <div class="field is-pulled-left">
                <input @change="set_project_features()" v-model="is_features" class="is-checkradio is-info is-small"
                  type="checkbox" :id="'feature' + project.uid" />
                <label :for="'feature' + project.uid">
                  <span>
                    {{ localization("app-features", "Features") }}
                  </span>
                </label>
              </div>
            </div>
          </div>
          <input @change="changeOpacity($event)" v-model="opacity" class="slider is-circle" step="1" min="0" max="100"
            value="100" type="range" />
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import APIService from "@/services/api.service";
import FeatureService from "@/services/feature.service";
import _ from "lodash";

export default {
  props: [
    "project",
    "is_group_ortho",
    "is_group_features",
    "index",
    "group_index",
  ],
  data() {
    return {
      is_open_collapse: false,
      apiService: new APIService(),
      featureService: new FeatureService(),
      opacity: 100,
      is_ortho: false,
      is_features: false,
    };
  },
  created() {
    if (this.index == 0 && this.group_index == 0) {
      this.$parent.$on("fly", this.fly);
      setTimeout(() => {
        this.is_ortho = true;
        this.is_features = true;
        this.fly();
        this.SET_ACTIVE_PROJECT(this.project);
        this.set_ortho_layer();
      }, 2000);
    }
  },
  computed: {
    ...mapState([
      "map",
      "features",
      "active_projects",
      "active_project",
      "draw",
    ]),
  },
  watch: {
    is_group_ortho: {
      immediate: true,
      handler(val) {
        this.is_ortho = val;
        this.set_ortho_layer(false);
      },
    },
    is_group_features: function (val) {
      this.is_features = val;
      this.set_project_features();
    },
    active_project: function (val) {
      this.watch_active_project_and_draw();
    },
    draw: function (val) {
      this.watch_active_project_and_draw();

      if (this.index == 0 && this.group_index == 0) {
        this.$parent.$on("fly", this.fly);
        this.is_ortho = true;
        this.is_features = true;
        this.fly();
        this.SET_ACTIVE_PROJECT(this.project);
        this.set_ortho_layer();
      }

      this.map.on("style.load", () => {
        if (this.is_ortho) {
          this.set_ortho_layer(false);
        }
        if (this.is_features) {
          this.set_project_features(false);
        }
      });
    },
  },
  methods: {
    ...mapMutations([
      "SET_ACTIVE_PROJECT",
      "UPDATE_ACTIVE_PROJECTS",
      "FILTER_FEATURES_BY_PROJECT",
      "SET_IS_LOADING",
    ]),
    download_report() {
      if (
        this.project.reports &&
        this.project.reports.report
      ) {
        this.apiService
          .get_report_url({
            project_uid: this.project.uid,
            container_uid: this.$route.params.uid
          }).then((res) => {
            this.project.reports.report.url = res.data.reports.report.url
            window.open(this.project.reports.report.url, "_blank");

          })

      }

      // this.apiService
      //   .get_report_download_link({ url: this.project.reports.report.url })
      //   .then(res => {});
    },
    watch_active_project_and_draw() {
      if (this.draw && this.active_project) {
        if (this.active_project.uid === this.project.uid) {
          this.is_ortho = true;
          this.is_features = true;
          this.set_project_features();
        } else {
          this.is_ortho = false;
          this.is_features = false;
          this.set_project_features();
        }
      }
    },
    changeOpacity() {
      this.map.setPaintProperty(
        "MAPLAYER:" + String(this.project.uid),
        "raster-opacity",
        parseInt(this.opacity, 10) / 100
      );
    },
    fly() {
      let fly_to_location;
      if (
        this.active_projects[this.project.uid] &&
        this.active_projects[this.project.uid].meta &&
        this.active_projects[this.project.uid].meta.center
      ) {
        fly_to_location = this.active_projects[
          this.project.uid
        ].meta.center.slice(0, 2);
      } else if (
        this.active_projects[this.project.uid] &&
        this.active_projects[this.project.uid].features &&
        this.active_projects[this.project.uid].features.length
      ) {
        let centroid = turf.centroid({
          type: "FeatureCollection",
          features: [this.active_projects[this.project.uid].features[0]],
        });
        fly_to_location = centroid.geometry.coordinates;
      }
      if (fly_to_location && this.$store.state.fly_active) {
        this.map.flyTo({
          center: fly_to_location,
          zoom: 17,
          speed: 5,
        });
      }
    },
    set_project_features(is_fly = true) {
      console.log("set_project_features(is_fly = true)", this.project.uid);
      if (
        this.active_projects[this.project.uid] &&
        this.active_projects[this.project.uid].features
      ) {
        if (this.is_features)
          this.$store.commit(
            "UPDATE_FEATURES_LOCATION_MAP",
            this.active_projects[this.project.uid].features
          );
        this.FILTER_FEATURES_BY_PROJECT({
          project: this.project,
          active: this.is_features,
        });
        return;
      }
      if (this.is_features === false) {
        let to_remove = _.filter(
          this.draw.getAll().features,
          (feature) => feature.properties.project === this.project.uid
        );
        let filtered_featureIds = _.map(to_remove, (feature) => feature.id);
        this.draw.delete(filtered_featureIds);
        this.UPDATE_ACTIVE_PROJECTS({
          payload: {
            ...this.active_projects[this.project.uid],
            is_feature_active: false,
            is_ortho_active: false,
          },
          layer: this.project,
        });
      } else if (this.is_features === true) {
        if (
          this.active_projects[this.project.uid] &&
          this.active_projects[this.project.uid].features
        ) {
          this.draw.add({
            type: "FeatureCollection",
            features: this.active_projects[this.project.uid].features,
          });
          this.$store.commit(
            "UPDATE_FEATURES_LOCATION_MAP",
            this.active_projects[this.project.uid].features
          );
        } else {
          this.SET_IS_LOADING(true);
          this.featureService
            .get_project_features({
              uid: this.project.uid,
              query: "issue=true",
            })
            .then((res) => {
              this.SET_IS_LOADING(false);
              this.draw.add({
                type: "FeatureCollection",
                features: res.data.features,
              });
              this.$store.commit(
                "UPDATE_FEATURES_LOCATION_MAP",
                res.data.features
              );

              this.UPDATE_ACTIVE_PROJECTS({
                payload: {
                  ...this.active_projects[this.project.uid],
                  features: res.data.features,
                  is_feature_active: true,
                },
                layer: this.project,
              });
              this.$root.$emit("FEATURES_LOADED", {
                project: this.active_project,
              });
              if (is_fly) this.fly();
            })
            .catch((err) => {
              this.handleErrors(err);
              this.SET_IS_LOADING(false);
            });
        }
      }
    },
    set_ortho_layer(is_fly = true) {
      try {
        if (
          this.map &&
          this.project.reports &&
          this.project.reports.orthotiles &&
          this.project.reports.orthotiles.tile_url &&
          !this.map.getSource("MAPSOURCE:" + String(this.project.uid))
        ) {
          this.map.addSource("MAPSOURCE:" + String(this.project.uid), {
            type: "raster",
            tiles: [
              `${this.project.reports.orthotiles.tile_url}/{z}/{x}/{y}.png`,
            ],
            tileSize: 256,
          });
        }
        let payload = this.active_projects[this.project.uid];
        // Add project in active projects list
        if (!payload) {
          payload = {};
          payload.is_ortho_active = this.is_ortho;
          payload.is_feature_active = this.is_features;
          payload.info = this.project;
          payload.features = null;
          payload.filtered_features = [];
          this.UPDATE_ACTIVE_PROJECTS({ payload, layer: this.project });
        } else {
          payload.is_ortho_active = this.is_ortho;
          payload.is_feature_active = this.is_features;
          this.UPDATE_ACTIVE_PROJECTS({ payload, layer: this.project });
        }

        if (
          this.project.reports &&
          this.project.reports.orthotiles &&
          this.project.reports.orthotiles.tile_url &&
          !this.active_projects[this.project.uid].meta
        ) {
          this.apiService
            .get_project_orthotiles_meta({
              url: this.project.reports.orthotiles.tile_url,
            })
            .then((results) => {
              payload.meta = results.data;
              this.UPDATE_ACTIVE_PROJECTS({ payload, layer: this.project });

              this.set_layer(is_fly);
            })
            .catch((err) => {
              this.handleErrors(err);
            });
        } else {
          if (this.map.getSource("MAPSOURCE:" + String(this.project.uid)))
            this.set_layer(is_fly);
        }
        if (is_fly) this.fly();
      } catch (err) {
        console.log(err);
        console.log("Error:: while loading map source for !");
      }
    },
    set_layer(is_fly) {
      if (
        !this.is_ortho &&
        this.map.getLayer("MAPLAYER:" + String(this.project.uid))
      ) {
        this.map.setLayoutProperty(
          "MAPLAYER:" + String(this.project.uid),
          "visibility",
          "none"
        );
      } else {
        if (this.map.getLayer("MAPLAYER:" + String(this.project.uid)))
          this.map.setLayoutProperty(
            "MAPLAYER:" + String(this.project.uid),
            "visibility",
            "visible"
          );
        else
          this.map.addLayer(
            {
              id: "MAPLAYER:" + String(this.project.uid),
              type: "raster",
              source: "MAPSOURCE:" + String(this.project.uid),
              paint: {
                "raster-opacity": parseInt(this.opacity, 10) / 100,
              },
            },
            "gl-draw-polygon-fill-inactive.cold"
          );
      }
      if (this.is_ortho && is_fly) this.fly();
    },
  },
};
</script>

<style lang="scss" scoped>
.flyto-btn {
  cursor: pointer;
  margin-left: 10px;
}

.card {
  border: none;
  box-shadow: none;
}

.project__btns {
  display: flex;
  justify-content: flex-start;
}

.project {
  display: flex;
  width: 100%;
  text-align: center;
  transition: all 0.2s;
  font-weight: 300;

  &__btns {
    margin-bottom: 0;

    .column {
      padding: 0;
    }
  }

  &__field.has-addons {
    margin: 0;

    display: flex;
    justify-content: flex-start;
    padding: 0;
  }

  .field .control {
    margin-bottom: 0;
  }

  label {
    padding: 0;
  }

  .card-content {
    padding: 0 3px;
  }

  &__name {
    &.active_cluster {
      color: blue;
    }

    opacity: 0.8;

    &.active-project {
      opacity: 1;
    }

    // font-size: 15px;
    width: 150px;
    text-align: left;
    overflow: hidden;
  }

  .slider {
    width: 100%;
    margin-bottom: 1.8rem;
    padding-top: 0rem;
    margin-top: 0;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    /* Override default look */
    appearance: none;
    cursor: pointer;
    /* Cursor on hover */
    width: 18px;
    height: 18px;
    box-shadow: 0 3px 6px 0 rgba(139, 147, 169, 0.5);
    border: solid 2px #8d95aa;
    background-color: #ffffff;
    margin-top: -6px;
  }

  .is-checkradio[type="checkbox"].is-small+label {
    font-size: 14px;
    font-family: Barlow-Medium;
    line-height: 42px;
    font-weight: 500;
    opacity: 0.7;
    color: #171e48;
  }

  .is-checkradio[type="checkbox"].is-small+label::before,
  .is-checkradio[type="checkbox"].is-small+label:before {
    margin-top: 3px;
  }

  .is-checkradio[type="checkbox"].is-small+label::after,
  .is-checkradio[type="checkbox"].is-small+label:after {
    top: 0.40375rem;
  }
}
</style>
